module.exports = __webpack_public_path__ + "img/logofs_icon.f96d435b.svg";